import AccordionMenu from './AccordionMenu';

export default AccordionMenu;
